webpackJsonp([82],{

/***/ 1185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function setting(vm) {
	return vm.$resource('setting{/id}');
}

/* harmony default export */ __webpack_exports__["a"] = (setting);

/***/ }),

/***/ 1358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resource_setting__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_RoomStatus__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_RoomStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_RoomStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_FilterList__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_shared_FilterList__);




var loadData = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filterGroups, sortGroup, state) {
		var parameters, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						parameters = {
							limit: this.limit,
							page: this.page
						};

						if (filterGroups) {
							parameters.filter_groups = filterGroups;
						}
						if (sortGroup) {
							parameters.sort = sortGroup;
						}
						_context.next = 5;
						return this.resource.get(parameters);

					case 5:
						response = _context.sent;

						if (!state) {
							this.filterValue = 1;
						}
						this.totalPages = response.data.last_page;
						this.rows = response.data.data.map(function (row) {
							var newRow = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, row);
							newRow.isSelected = false;
							newRow.isAdded = false;
							return newRow;
						});
						this.loading = false;

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData(_x, _x2, _x3) {
		return _ref2.apply(this, arguments);
	};
}();

var changeState = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
		var id = _ref4.id;
		var modelRow;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						modelRow = this.rows.filter(function (row) {
							return row.id === id;
						})[0];
						_context2.next = 3;
						return this.resource.update({ id: id }, modelRow);

					case 3:
						this.loadData();

					case 4:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function changeState(_x4) {
		return _ref3.apply(this, arguments);
	};
}();

var deleteRow = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6) {
		var id = _ref6.id;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.next = 2;
						return this.resource.delete({ id: id });

					case 2:
						this.loadData();

					case 3:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function deleteRow(_x5) {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var helperData = __WEBPACK_IMPORTED_MODULE_6__shared_helper__["a" /* default */].data();

function mounted() {
	this.resource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__resource_setting__["a" /* default */])(this);
	this.loadData();
}

function columnSortableEvent(_ref) {
	var id = _ref.id;

	var self = this;
	var newColumn = self.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.id !== newColumn[0].id) {
			newColumnSingle.isSortable = { down: true, up: false };
		}
		return newColumnSingle;
	});
	var sortGroupAsc = [{
		key: newColumn[0].code,
		direction: newColumn[0].isSortable.up ? 'ASC' : 'DSC'
	}];
	this.loadData(null, sortGroupAsc);
}

function goToEdit(_ref7) {
	var id = _ref7.id;

	var editHref = { name: 'settings-config', params: { settingId: id } };
	this.$router.push(editHref);
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function searchByColumn(search) {
	var filterGroup = [{
		filters: [{
			key: 'name',
			value: search,
			operator: 'ct'
		}]
	}];
	this.loadData(filterGroup);
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
	if (filter.id === 2) {
		var filterGroup = [{
			filters: [{
				key: 'flag_active',
				value: 1,
				operator: 'eq'
			}]
		}];
		this.loading = true;
		this.loadData(filterGroup, null, filter.id);
	} else if (filter.id === 3) {
		var _filterGroup = [{
			filters: [{
				key: 'flag_active',
				value: 0,
				operator: 'eq'
			}]
		}];
		this.loading = true;
		this.loadData(_filterGroup, null, filter.id);
	} else {
		this.loading = true;
		this.loadData();
	}
}

function changePage(value) {
	this.page = value;
	this.loadData();
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_8__components_shared_ButtonCreate___default.a,
		FilterList: __WEBPACK_IMPORTED_MODULE_9__components_shared_FilterList___default.a,
		RoomStatus: __WEBPACK_IMPORTED_MODULE_7__components_shared_RoomStatus___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_3_table_run___default.a
	},
	computed: {
		pagesVisible: pagesVisible
	},
	data: function data() {
		return {
			columns: [{ id: 1, name: 'Types of state', code: 'code_setting', isSortable: { down: true, up: false } }, { id: 2, name: 'Full name', code: 'name', isSortable: { down: true, up: false } }, { id: 3, name: 'Created date', code: 'created_at', isSortable: { down: true, up: false } }],
			createHref: { name: 'settings-new' },
			filterValue: 1,
			limit: 10,
			loading: false,
			page: 1,
			preimage: helperData.preimageUrl,
			resource: null,
			rows: [],
			totalPages: 5
		};
	},

	name: 'settings',
	methods: {
		changePage: changePage,
		changeState: changeState,
		columnSortableEvent: columnSortableEvent,
		deleteRow: deleteRow,
		goToEdit: goToEdit,
		loadData: loadData,
		searchByColumn: searchByColumn,
		selectedFilter: selectedFilter
	},
	mixins: __WEBPACK_IMPORTED_MODULE_4__shared_mixins__["a" /* default */],
	mounted: mounted
});

/***/ }),

/***/ 1702:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md10": ""
    }
  }, [_c('filter-list', {
    staticClass: "mb-3",
    attrs: {
      "value": _vm.filterValue,
      "loading": _vm.loading
    },
    on: {
      "selected-filter": _vm.selectedFilter
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "md2": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": "Tipo de limpieza",
      "href": _vm.createHref
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-switch": true,
      "include-settings": true,
      "include-delete-single": true,
      "selectable": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn,
      "on-change-state": _vm.changeState,
      "on-delete-event": _vm.deleteRow,
      "go-to-edit-page": _vm.goToEdit
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [(props.row.url_image && props.row.url_image !== _vm.preimage) ? _c('room-status', {
          attrs: {
            "background-color": props.row.color_setting,
            "status-icon-img": props.row.url_image,
            "size": 'small',
            "name": props.row.code_setting,
            "room": props.row
          }
        }) : _c('room-status', {
          attrs: {
            "background-color": props.row.color_setting,
            "status-icon": props.row.icon_url,
            "size": 'small',
            "name": props.row.code_setting,
            "room": props.row
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.created_at))])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1358),
  /* template */
  __webpack_require__(1702),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/82.927df1eae5d49bf3d14c.js